import { Occupation, Occupations, Translations } from "@salaxy/core";
import { SessionService } from "../../services";
import { InputController } from "./InputController";

/**
 * Controller behind form controls that select an occupation type.
 */
export class InputOccupationTypeController extends InputController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["SessionService"];

  /**
   * One or a list of occupation IDs or a known keyword to define which occupations are shown
   * Supported keywords: 'household' and 'company'
   */
  public defaultList: string;

  /**
   * Creates a new InputOccupationTypeController
   * @ignore
   */
  constructor(private sessionService: SessionService) {
    super();
  }

  /** Sets the default values in init. */
  public $onInit() {
    super.$onInit();
  }

  /** Gets the list of occupations in the search field. */
  public getOccupations = (searchString: string): any => {
    let occupations: Occupation[];
    if (!searchString || searchString.length < 2) {
      const defaultList = this.defaultList || (this.sessionService.isInSomeRole("household,worker") ? "household" : "company");
      occupations = Occupations.getByIds(defaultList);
    } else {
      occupations = Occupations.search(searchString);
    }

    return occupations.map(item => ({
      value: item.id,
      text: item.label,
      object: item
    }));
  };

  /**
   * Returns the label for given occupation id.
   * @param occupationId - Id of the occupation.
   */
  public getOccupationLabel(occupationId: string): string {
    for (const occupation of Occupations.getAll(null)) {
      if (occupationId === occupation.id) {
        return occupation.label;
      }
    }
    return occupationId;
  }

  /** Returns the placeholder text - this control has a default text. */
  public getPlaceholder() {
    return super.getPlaceholder() || Translations.get("SALAXY.NG1.InputOccupationType.getPlaceholder");
  }
}
